module.exports = __webpack_public_path__ + "img/sparkles_circles.8d5fdfc6.svg";